/** The newline keeps both tile labels on two lines at any tile width; rendered with whiteSpace: pre-line. */
export const PHOTO_UPLOAD_FROM_COMPUTER_TEXT = 'Add from\ncomputer';
export const PHOTO_UPLOAD_FROM_PHONE_TEXT = 'Add from\nphone';
